// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

import {CodeEditor} from '../../CodeEditor';
import {RunQueueItem} from '../../types';

export type RunQueueItemConfigurationProps = {
  runQueueItem: RunQueueItem;
};

export const RunQueueItemConfiguration = ({
  runQueueItem,
}: RunQueueItemConfigurationProps) => {
  const [expanded, setExpanded] = useState(true);
  const [fullConfigExpanded, setFullConfigExpanded] = useState(true);
  const iconName = expanded ? 'chevron-down' : 'chevron-next';

  const runSpec = runQueueItem.runSpec;
  const runConfigurations = runSpec.overrides ?? {};
  const runConfigurationsString = JSON.stringify(runConfigurations, null, 2);
  const templateVariables = runQueueItem.templateVariableValues;
  const resourceArgs = runSpec.resource_args[runSpec.resource] ?? {};

  return (
    <div className="m-16 mt-32">
      <div className="flex items-center py-8">
        <Icon name={iconName} onClick={() => setExpanded(!expanded)} />
        <div className="px-4 text-[18px] font-semibold">Configurations</div>
      </div>
      {expanded && (
        <div className="px-24 pb-8">
          <div className="py-8">
            <div className="py-8 font-semibold">Run Configurations</div>
            <CodeEditor
              value={runConfigurationsString}
              language="json"
              readOnly={true}
            />
          </div>
          {templateVariables && (
            <div className="py-8">
              <div className="py-8 font-semibold">Template Variables</div>
              {Object.entries(templateVariables).map(([key, value]) => {
                return (
                  <div key={key} className="flex pt-8">
                    <div className="mr-4 bg-moon-100 px-4 text-sm text-sienna-500">
                      {key}
                    </div>
                    <div>: {value}</div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="py-8">
            <div className="flex items-center">
              <div className="mr-8 font-semibold">
                Complete queue configurations
              </div>
              <Button
                size="small"
                variant="secondary"
                onClick={() => setFullConfigExpanded(!fullConfigExpanded)}>
                Hide
              </Button>
            </div>
            {fullConfigExpanded && (
              <div className="pt-8">
                <CodeEditor
                  value={JSON.stringify(resourceArgs, null, 2)}
                  language="json"
                  readOnly={true}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
